// eslint-disable-next-line import/prefer-default-export
export const imageTypes = [
  'gif', 'png', 'apng', 'ico', 'cur', 'jpg', 'jpeg', 'jfif', 'svg',
];
